import { Alert } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
const EvaluationExpired = ({ onDismiss }) => {
    const { t } = useTranslation();
    return (<Alert title={t('financing.evaluation_expired.alert_title')} variant="info" onClose={onDismiss}>
            <div className="body-m">{t('financing.evaluation_expired.alert_message')}</div>
        </Alert>);
};
export default EvaluationExpired;
